import {useEffect, useMemo} from 'react';

import {setDocumentDescription, setDocumentTitle} from '../../util/document';
import {useProjectParams} from './useProjectParams';

type ConfigProps = {
  reportCount: number;
  runCount: number;
  sweepCount: number;
};
export function useDocumentMeta({
  reportCount,
  runCount,
  sweepCount,
}: ConfigProps) {
  const {entityName, projectName, tab} = useProjectParams();

  const tabDescription: string = useMemo(() => {
    switch (tab) {
      case `overview`:
        return `Overview`;
      case `table`:
        return `Table`;
      case `reportlist`:
        return `Reports`;
      case `sweeps`:
        return `Sweeps`;
      case `launch`:
        return `Launch`;
      case 'jobs':
        return 'Jobs';
      case 'triggers':
        return 'Triggers';
      case `artifacts`:
        return `Artifacts`;
      case `workspace`:
      default:
        return 'Workspace';
    }
  }, [tab]);

  useEffect(() => {
    setDocumentTitle(`${projectName} ${tabDescription}`);
    setDocumentDescription(
      `${tabDescription} of ${projectName}, a machine learning project by ${entityName} using Weights & Biases with ${runCount} runs, ${sweepCount} sweeps, and ${reportCount} reports.`
    );
  }, [
    tab,
    tabDescription,
    projectName,
    entityName,
    runCount,
    sweepCount,
    reportCount,
  ]);
}
